<script setup lang="ts">
import { tryOnBeforeMount } from '@vueuse/core';
import { toRefs, inject } from 'vue';
import { useRedirect } from '../composables/useRedirect';
import { useTracking } from '../composables/useTracking';
import { isInDocoiApp, isMiniProgram, isInGame, navbarHeight, isInWebCommunity } from '../utils/app';
import { isIOS } from '../utils/device';

const props = withDefaults(
  defineProps<{
    title?: string;
    subTitle?: string;
    describe?: string;
    trackData?: any;
    showShareBtn?: boolean;
    hasHeight?: boolean;
    dart?: boolean;
    maxWidth?: string;
  }>(),
  {
    showShareBtn: true,
    hasHeight: true,
    dart: false,
    maxWidth: '100%'
  }
);

const { title, describe, trackData, showShareBtn, hasHeight, maxWidth } = toRefs(props);
const { trackClick } = useTracking();
const redirect = useRedirect();

const documentHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
};

tryOnBeforeMount(() => {
  window.addEventListener('resize', documentHeight);
  documentHeight();
});
const handleOpenApp = inject<() => any>('openApp');
const handleOpenAppClick = () => {
  trackData.value && trackClick(trackData.value);
  handleOpenApp?.();
};
</script>
<template>
  <template v-if="isInDocoiApp() || isMiniProgram|| isInWebCommunity()">
    <slot></slot>
  </template>
  <div
    v-else
    class="share-wrapper flex-col"
    :style="{ marginTop: isInGame && isIOS ? `${navbarHeight()}rem` : '0', maxWidth }">
    <div class="flex-shrink-0" :style="{ height: hasHeight ? ' 1.4667rem' : '' }"></div>
    <div class="navbar center-y flex-row justify-between z-1501" :class="dart ? 'dart' : 'light'">
      <div class="center-y gap-x-4">
        <SvgIcon
          v-if="isInGame"
          name="arrow_left"
          width=".24rem"
          height=".4rem"
          @click="redirect.back"
          :color="dart ? '#fff' : '#000'" />
        <img class="logo" src="https://cdn.docoi.cc/static/h5_assets/public/logo_3x.png" alt="logo" srcset="" />
        <div class="lh15">
          <p class="text-15 mt-2" :class="dart ? 'textdart' : 'textlight'">
            <span class="fw-500">{{ title || '梦游社App' }}</span>
            <span v-if="subTitle">{{ subTitle }}</span>
          </p>
          <p class="text-13 fw400" :style="{ color: dart ? '#FFFFFF99' : 'black' }">{{ describe || '圈住你的热爱' }}</p>
        </div>
      </div>
      <van-button
        class="call-app-btn-top"
        v-btn
        @click="handleOpenAppClick"
        size="small"
        type="primary"
        round
        :style="{ color: dart ? '#fff' : null }">
        打开App
      </van-button>
    </div>
    <slot :handleOpenApp="handleOpenAppClick"></slot>
    <van-button
      v-if="showShareBtn"
      class="call-app-btn-bottom"
      @click="handleOpenAppClick"
      size="small"
      type="primary"
      round>
      App内打开
    </van-button>
  </div>
</template>
<style lang="scss" scoped>
.share-wrapper {
  @apply bg-white of-hidden relative mx-auto w-full;
  height: var(--doc-height) !important;
  .navbar {
    @apply w-full h-55 absolute top-0 left-0 px-12 bg-white;

    &.light {
      @apply bg-white;
    }

    &.dart {
      @apply bg-black;
    }

    & .textlight {
      @apply color-text;
    }

    & .textdart {
      @apply text-white;
    }

    .logo {
      @apply mr-6 w-40 h-40;
    }
  }

  .share-content {
    @apply flex-1;
  }

  .call-app-btn-top {
    @apply w-73 h-28 text-14 text-white bg-primary border-primary transition-all duration-200;
    color: #fff !important;
  }

  .call-app-btn-bottom {
    @apply absolute left-1/2 bottom-60 z-100 w-131 h-40 rounded-40 text-15 font-500 bg-#3cffd0 border-#3cffd0 transition-all duration-200;
    box-shadow: 0 0 0.2133rem 0 #3cffd171;
    color: #00656c !important;
    transform: translateX(-50%);
  }
}
</style>
